import { OfferRequest } from "../models/OfferRequest";
import { Insured } from "../models/Insured";
import { ScoreRequest } from "../models/ScoreRequest";

import bus from "./bus.js";

export default function requestOffers(vue, productAlreadySelected=false){

    const offerRequest = new OfferRequest();

    if(vue.$store.state.site==="cibc"){
      offerRequest.Configuration.ClientCode="CIBC";
    }
    else {
      offerRequest.Configuration.ClientCode="CIBCIndividual";
    }

    offerRequest.Coverage.PurchaseDate = vue.$moment().format("YYYY-MM-DD");
    offerRequest.Coverage.PricingDate = vue.$moment().format("YYYY-MM-DD");
    if(vue.$route.name==="TravelPlans"){
      offerRequest.Coverage.StartDate = vue.$moment(document.getElementById("departureDate").value,"MM/DD/YYYY").format("YYYY-MM-DD");
      offerRequest.Coverage.EndDate = vue.$moment(document.getElementById("returnDate").value,"MM/DD/YYYY").format("YYYY-MM-DD");          
      offerRequest.Coverage.ProvinceOfResidence = document.getElementById("province").value;
    }
    else {
      offerRequest.Coverage.StartDate = vue.$moment(vue.$store.state.departureDate,"MM/DD/YYYY").format("YYYY-MM-DD");
      offerRequest.Coverage.EndDate = vue.$moment(vue.$store.state.returnDate,"MM/DD/YYYY").format("YYYY-MM-DD");
      offerRequest.Coverage.ProvinceOfResidence = vue.$store.state.province;
    }
    
    let numberOfTravellers;
    if(vue.$route.name==="TravelPlans"){
      numberOfTravellers=document.getElementById('numberOfTravellers').value;
    } else {
      numberOfTravellers=vue.$store.state.numberOfTravellers
    }
    for(let i=1; i<=10;i++){
      if(i<=numberOfTravellers){
        const traveller = new Insured;

        if(vue.$route.name==="TravellerAges"){
          traveller.DateOfBirth=vue.$moment(document.getElementById("traveller"+i+"_dob").value,"MM/DD/YYYY").format("YYYY-MM-DD");
        } else if(vue.$route.name==="TravelPlans"){
          traveller.DateOfBirth=vue.$moment(document.getElementById("oldestTraveller_dob").value,"MM/DD/YYYY").format("YYYY-MM-DD");
        } else {
          traveller.DateOfBirth=vue.$moment(vue.$store.state["traveller"+i+"_dob"],"MM/DD/YYYY").format("YYYY-MM-DD");
        } 

        if(vue.$route.name==="TravelPlans"){
          if(document.getElementById("tripCost").value===""){
            traveller.CoverageAmount= "0";
          }
          else {
            traveller.CoverageAmount= document.getElementById("tripCost").value;
          }
        } else {
          if(vue.$store.state.tripCost===""){
            traveller.CoverageAmount= "0";
          }
          else {
            traveller.CoverageAmount= vue.$store.state.tripCost;
          }
        }

        if(i===1) {
          traveller.IsPrimaryInsured=true;
          offerRequest.Coverage.Insured = [traveller];
        }
        else {
          traveller.IsPrimaryInsured=false;
          offerRequest.Coverage.Insured.push(traveller);
        }
      }
    }

    vue.isLoading=true;
    vue.$store.commit("setOfferRequest", offerRequest);
    // If Questionnnaire has just been filled out, send the survey answers
    if(vue.$route.name==="Questionnaire3") {
      const scoreRequest = new ScoreRequest();
      scoreRequest.Answers = [
        {
          "QuestionId": "q1-1",
          "Response": "true"
        },
        {
          "QuestionId": "q2-1a",
          "Response": vue.$store.state.medicalQuestion2
        },
        {
          "QuestionId": "q2-1b",
          "Response": vue.$store.state.medicalQuestion3
        },
        {
          "QuestionId": "q2-1c",
          "Response": vue.$store.state.medicalQuestion4
        },
        {
          "QuestionId": "q2-1d",
          "Response": vue.$store.state.medicalQuestion5
        },
        {
          "QuestionId": "q2-1e",
          "Response": vue.$store.state.medicalQuestion6
        },
        {
          "QuestionId": "q2-1f",
          "Response": vue.$store.state.medicalQuestion7
        },
        {
          "QuestionId": "q2-2a",
          "Response": vue.$store.state.medicalQuestion8
        },
        {
          "QuestionId": "q2-2b",
          "Response": vue.$store.state.medicalQuestion9
        },
        {
          "QuestionId": "q2-2c",
          "Response": vue.$store.state.medicalQuestion10
        },
        {
          "QuestionId": "q2-3",
          "Response": vue.$store.state.medicalQuestion11
        },
        {
          "QuestionId": "q2-4",
          "Response": document.getElementById("mq12y").checked
        },
        {
          "QuestionId": "q2-5a",
          "Response": document.getElementById("mq13y").checked
        },
        {
          "QuestionId": "q2-5b",
          "Response": document.getElementById("mq14y").checked
        },
        {
          "QuestionId": "q2-5c",
          "Response": document.getElementById("mq15y").checked
        },
        {
          "QuestionId": "q2-5d",
          "Response": document.getElementById("mq16y").checked
        },
        {
          "QuestionId": "q2-5e",
          "Response": document.getElementById("mq17y").checked
        },
        {
          "QuestionId": "q2-5f",
          "Response": document.getElementById("mq18y").checked
        },
        {
          "QuestionId": "q2-5g",
          "Response": document.getElementById("mq19y").checked
        },
        {
          "QuestionId": "q2-5h",
          "Response": document.getElementById("mq20y").checked
        },
        {
          "QuestionId": "q2-5i",
          "Response": document.getElementById("mq21y").checked
        },
        {
          "QuestionId": "q2-5j",
          "Response": document.getElementById("mq22y").checked
        },
        {
          "QuestionId": "q2-5k",
          "Response": document.getElementById("mq23y").checked
        },
        {
          "QuestionId": "q2-5l",
          "Response": document.getElementById("mq24y").checked
        },
        {
          "QuestionId": "q3-1",
          "Response": document.getElementById("mq25y").checked
        }
      ];
      vue.$store.commit("setAnswers", scoreRequest.Answers);
      scoreRequest.getScore(
        function callbackChangeStep(status, responseText) {
          if(status===200){
            if(responseText.Result==="Pass"){
              bus.$emit("sendOfferRequest", responseText);
            }
            else {
              bus.$emit("APIError","RWEC0022");
            }
          }
          else {
            bus.$emit("APIError","RWEC0021");
          }
          bus.$emit("hideLoading");
        });
    }
    else {
      bus.$emit("sendOfferRequest");
    }
}